import { render, staticRenderFns } from "./FeatureTypeDisplay.vue?vue&type=template&id=3985ddb4&scoped=true"
import script from "./FeatureTypeDisplay.vue?vue&type=script&lang=js"
export * from "./FeatureTypeDisplay.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeDisplay.vue?vue&type=style&index=0&id=3985ddb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985ddb4",
  null
  
)

export default component.exports